<div cllTooltip="{{ dateRange.start | appDate }} - {{ dateRange.end | appDate }}"
     style="display: inline-block"
     class="hover-dotted dotted">
    {{ dateRange | appDateRange }}
</div>
